import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'zero-state-mx-data',
  templateUrl: './zero-state-mx-data.component.html',
  styleUrls: ['./zero-state-mx-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZeroStateMxDataComponent implements OnInit {
  @Output() addDataFeedEvent = new EventEmitter();
  @Output() addUserAccountEvent = new EventEmitter<any>();
  @Input() dataFeedSource;
  @Input() inlineComponent = false;
  @Input() availableDataFeeds = [];

  constructor() {}

  ngOnInit(): void {}

  addDataFeed(type: string) {
    this.addDataFeedEvent.emit({ type });
  }

  addUserAccount(item: any) {
    this.addUserAccountEvent.emit(item);
  }
}
